import React, { useContext } from "react";
import { ControlLabel, FormGroup } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setInstallerSandbox } from "../actions/sandbox";
import { MainContext } from "../../../views/MainWindow";
import Toggle from "../../../controls/Toggle";
function Sandbox(props) {
    const { osSupportsAppContainer } = props;
    const { t } = useTranslation();
    const sandboxEnabled = useSelector((state) => state.settings.mods.installerSandbox ?? true);
    const dispatch = useDispatch();
    const context = useContext(MainContext);
    const toggleSandbox = React.useCallback(() => {
        if (osSupportsAppContainer) {
            context.api.events.emit("analytics-track-click-event", "Workarounds", sandboxEnabled ? "Disable Sandbox" : "Enable Sandbox");
            dispatch(setInstallerSandbox(!sandboxEnabled));
        }
    }, [sandboxEnabled]);
    return (React.createElement("form", null,
        React.createElement(FormGroup, { id: "dotnet-appcontainer", controlId: "appcontainer" },
            React.createElement(ControlLabel, null, t("Installer Sandbox")),
            React.createElement(Toggle, { checked: sandboxEnabled && osSupportsAppContainer, onToggle: toggleSandbox, disabled: !osSupportsAppContainer }, t("Enable Sandbox")))));
}
export default Sandbox;
